import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { SubmitButtonComponent } from 'components/input/submit-button/submit-button.component';
import { ListItemComponent, ListViewComponent } from 'components/layout/list-view/list-view.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { CompanyQueryModel } from 'models/generated/Models.CompanyQuery';
import { CompanySearchResultViewModel } from 'models/generated/Models.CompanySearchResultView';
import { Layout } from 'modules/layout';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CompanyService } from 'services/company.service';
import { CredentialRequired, CredentialService } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';

@Component({
	selector: 'edit-company',
	templateUrl: './edit-company.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, CustomInputComponent, ListViewComponent, ListItemComponent, TranslatePipe, CustomDatePipe]
})
@CredentialRequired(CredentialType.UpdateCompanyFromCvr)
export class EditCompany {
	inputTypeEnum = InputType;
	virkCompany?: CompanyModel;
	otherCompanyWithVatNumber?: CompanySearchResultViewModel;
	searchResult?: CompanySearchResultViewModel[];
	searchVatNumber = '';
	updateCompanyVatNumberCredential = CredentialType.UpdateCompanyVatNumber;

	@ViewChild('lookupVatNumberButton') lookupVatNumberButton?: SubmitButtonComponent;
	@ViewChild('updateCompanyByVatNumberButton') updateCompanyByVatNumberButton!: SubmitButtonComponent;


	@Input() _company!: CompanyModel;
	loading = false;

	set company(company: CompanyModel) {
		this._company = company;
		this.searchVatNumber = company.vatNumber;
		if (!this.credentialService.hasCredentials(CredentialType.UpdateCompanyVatNumber)) {
			this.lookupVatNumber();
		}
	}
	get company() {
		return this._company;
	}

	constructor(private readonly companyService: CompanyService, private readonly navigation: NavigationService, readonly credentialService: CredentialService) { }

	resetSearchResults() {
		this.searchResult = undefined;
		this.otherCompanyWithVatNumber = undefined;
	}

	async lookupVatNumber() {
		this.loading = true;
		this.searchResult = await this.companyService.searchCompany({ vatNumber: this.searchVatNumber } as CompanyQueryModel);
		this.otherCompanyWithVatNumber = this.searchResult.find(c => c.companyId !== this.company.id);
		if (!this.otherCompanyWithVatNumber) {
			this.virkCompany = await this.companyService.getCompanyVirkDataByVatNumber(this.searchVatNumber);
		}
		this.loading = false;
		if (this.lookupVatNumberButton) this.lookupVatNumberButton.reset();
	}

	updateCompanyByVatNumber() {
		this.companyService.updateCompanyByVatNumber(this.company.id!, this.searchVatNumber).then(() => this.navigation.closeView(this));
	}
}
